'use strict';

import setModalVideo from "../../../frontend/js/video-modal";

const pageListDelta = 6;
let pageListStartX;
let pageListStartY

class PageListVideoPlayer {
    constructor() {
        const watchLinks = document.querySelectorAll('.page-list-carousel-card--video');

        if (watchLinks.length > 0) {
            watchLinks.forEach(element => {
                element.addEventListener("mousedown", event => {
                    pageListStartX = event.pageX;
                    pageListStartY = event.pageY;
                })

                element.addEventListener('mouseup', function (event) {
                    if (event.which !== 1) {
                        return;
                    }
                    const diffX = Math.abs(event.pageX - pageListStartX);
                    const diffY = Math.abs(event.pageY - pageListStartY);

                    if (diffX < pageListDelta && diffY < pageListDelta) {
                        const videoId = element.dataset.videoId;
                        const videoHost = element.dataset.videoHost;
                        setModalVideo({ videoHost, videoId })
                    }
                });
            })
        }
    }
}
document.addEventListener("DOMContentLoaded", function () {
    new PageListVideoPlayer();
});